export default {
    methods: {
        formatDateFilter: function (from_year, from_era, to_year, to_era) {
            var query = []
            var selected = null

            // Create value to be displayed in selected filters
            if (from_year && to_year) {
                to_year = to_year.replace(/\D/g, '')
                from_year = from_year.replace(/\D/g, '')
                selected = from_year + ' ' + from_era + ' - ' + to_year + ' ' + to_era
                query['from_year'] = from_year
                query['from_era'] = from_era
                query['to_year'] = to_year
                query['to_era'] = to_era

            } else if (from_year && !to_year) {
                from_year = from_year.replace(/\D/g, '')
                selected = from_year + ' ' + from_era
                query['from_year'] = selected

            } else if (!from_year && to_year) {
                to_year = to_year.replace(/\D/g, '')
                selected = to_year + ' ' + to_era
                query['to_year'] = selected

            }

            return {
                'selected': selected,
                'query': query
            }
        }
    }
}
